import { render, staticRenderFns } from "./SendObituary.vue?vue&type=template&id=1c4b4f82"
import script from "./SendObituary.vue?vue&type=script&lang=js"
export * from "./SendObituary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports